import { motion } from "framer-motion";
import { resolveMedia } from "../siteContext";

export const CLIENTS = [
  { name: "Zain", img: "/api/images/1ee16030-4686-4710-9ff3-ca19cf630aab/file" },
  { name: "Kuwait Finance House", img: "/api/images/dab560a2-6d00-4038-bcec-2c2da67c7b45/file" },
  { name: "Mashreq", img: "/api/images/3b2c28aa-4e03-4dba-b53a-2c96999db4f2/file" },
  { name: "Ajman University", img: "/api/images/7ea90c9b-ff99-4afe-956e-1fdeb1cd2bd5/file" },
  { name: "Netflix", img: "/api/images/4784ae5e-d4cc-467a-9d7d-1676af011b18/file" },
  { name: "Al Tayer Group", img: "/api/images/6136fc46-e4ab-4c42-82f4-79f47a9df76f/file" },
  { name: "NBK", img: "/api/images/7f13615f-aa2f-4a75-84f2-0a6f89e8453b/file" },
  { name: "ADNOC", img: "/api/images/3b4a233c-3fb8-4db3-bbbb-af1792244a59/file" },
  { name: "IHG Hotels & Resorts", img: "/api/images/7e97e233-b689-47b7-aa6f-cb34aa00d3fe/file" },
  { name: "Millennium Hotels & Resorts", img: "/api/images/1859eff8-83b9-408c-a7b6-6bc81bf9007c/file" },
  { name: "Dior", img: "/api/images/8e3c4757-8948-4f98-864d-5593ce5ee6e5/file" },
  { name: "Beyond Transformation", img: "/api/images/4050ab38-4e35-4612-b0e9-7cc498d3b386/file" },
  { name: "Doomi Doo", img: "/api/images/449cc569-f55e-4ced-88a9-416eea5efa34/file" },
  { name: "St. Mary's — Sharjah, UAE", img: "/api/images/eedd977a-a00b-4b7e-b4f2-3d7fde7cde48/file" },
];

const ease = [0.22, 1, 0.36, 1];

export const ClientsWall = ({ compact = false }) => (
  <div className="rounded-[2rem] border border-luxury-gold/25 bg-[#FBF8F2] px-6 py-10 md:px-12 md:py-14 shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
    <div className={`grid ${compact ? "grid-cols-2 md:grid-cols-5" : "grid-cols-2 md:grid-cols-3 lg:grid-cols-5"} gap-x-8 gap-y-10 items-center`}>
      {CLIENTS.map((c, i) => (
        <motion.div
          key={c.name}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ delay: (i % 5) * 0.07, duration: 0.7, ease }}
          title={c.name}
          className="flex items-center justify-center h-16 md:h-20 hover:scale-105 transition-transform duration-400"
        >
          <img
            src={resolveMedia(c.img)}
            alt={c.name}
            loading="lazy"
            className="max-h-14 md:max-h-16 max-w-full w-auto object-contain"
          />
        </motion.div>
      ))}
    </div>
  </div>
);
